import { Integration } from "api/mutations/useToggleIntegrationMutation";

import { NoSetupIntegrations } from "components/Onboarding/hooks/useEnableNoSetUpIntegrations";

interface IntegrationResponse {
  status: "fulfilled" | "rejected";
  value?: { data: Integration };
  reason?: unknown;
}

interface IntegrationResponseSuccess {
  status: "fulfilled";
  value: { data: Integration };
}

const integrations = [
  NoSetupIntegrations.BigCommerce,
  NoSetupIntegrations.OracleNetSuite,
  NoSetupIntegrations.ClearBooks,
  NoSetupIntegrations.PrestaShop,
  NoSetupIntegrations.Kashflow,
];

const isFulfilled = (
  response: unknown
): response is IntegrationResponseSuccess =>
  (response as IntegrationResponseSuccess).value !== undefined;

export function calculateFailedResponses<
  Response extends IntegrationResponse[]
>(result: Response) {
  const fulfilledResponses = result.reduce(
    (accumulator: NoSetupIntegrations[], current: unknown) => {
      if (isFulfilled(current)) {
        return [...accumulator, current.value.data.name];
      }
      return accumulator;
    },
    []
  );

  const failedResponses = integrations.reduce(
    (accumulator: NoSetupIntegrations[], currentValue: NoSetupIntegrations) => {
      {
        if (fulfilledResponses.includes(currentValue)) {
          return accumulator;
        }
        return [...accumulator, currentValue];
      }
    },
    []
  );

  return failedResponses;
}
